<template>
  <div>
    <div class="pa-1 mt-2 bordered rounded bg-grey_3" v-if="mainStore.module.articles_boutique.list.length > 0">
      <v-sheet color="darkblue text-h6 pa-2">{{ mainStore.module.articles_boutique.total_order }} articles commandés au
        total</v-sheet>
      <div class="pa-1 my-2 bg-white bordered rounded" v-for="article in mainStore.module.articles_boutique.list"
        :key="article.id">
        <div class="text-body-1 font-weight-bold">
          {{ article.nom }}
        </div>

        <div class="d-flex sm-gap mb-2">
          <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{
            article.nb_reservations }}<span v-if="article.quantite > 0" class="mr-1">/{{ article.quantite }}</span>
            achetés</v-chip>
        </div>
        <v-progress-linear rounded :model-value="get_progress(article.nb_reservations, article.quantite)"
          color="darkblue" height="6"></v-progress-linear>
        <div class="ml-2" v-if="article.sizes && article.sizes.length > 0">
          <div class="text-subtitle-2">Par taille:</div>
          <div v-for="size in article.sizes" :key="size.nom">
            <div>
              {{ size.nom }} : {{ size.nb_reservations }}<span v-if="size.quantite > 0">/ {{ size.quantite }}</span>
              <v-progress-linear rounded :model-value="get_progress(size.nb_reservations, size.quantite)"
                color="orange-accent-3" height="5"></v-progress-linear>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <v-sheet elevation="0" class="text-h6 pa-2">Ce module n'a pas d'articles</v-sheet>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";

export default {
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),

  },
  methods: {
    get_progress(nb, max) {
      if (max == 0) return 2;
      return (nb / max) * 100;
    },


  },

};
</script>

<style lang="scss" scoped></style>